
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/recenzii",
      function () {
        return require("private-next-pages/user/recenzii/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/recenzii"])
      });
    }
  